(function (ng, app) {

    app.config([
        "$stateProvider",
        function ($stateProvider) {
            $stateProvider.state("Home",
                {
                    url: "",
                    component: "home",
                    redirectTo: "Home.Dashboard",
                    resolve: {
                        user: ["homeApi", function (homeApi) {
                            return homeApi.getUserInfo();
                        }],
                        //marketingDollars: ["homeApi", function (homeApi) {
                        //    return homeApi.getUserMarketingDollars().then(function (dollars) {
                        //        return dollars;
                        //    }, function () {
                        //        return 0;
                        //    });
                        //}],
                        userGroup: ["userGroupApi", "user", function (userGroupApi, user) {
                            if (user.UserGroupId)
                                return userGroupApi.get(user.UserGroupId);
                            return null;
                        }],
                        logo: ["userGroupApi", "user", "portalBaseApiUrl", function (userGroupApi, user, portalBaseApiUrl) {
                            if (user.UserGroupId) {
                                var logoUrl = portalBaseApiUrl + "/UserGroups/" + user.UserGroupId + "/Logo";
                                if (localStorage.getItem("UserGroupLogo") === null
                                    || localStorage.getItem("UserGroupLogo") !== logoUrl) {
                                    localStorage.setItem("UserGroupLogo", logoUrl);
                                    localStorage.setItem("UserGroupId", user.UserGroupId);
                                }
                                return logoUrl;
                            } else {
                                localStorage.removeItem("UserGroupLogo");
                                localStorage.removeItem("UserGroupId");
                            }
                            return null;
                        }],
                        delegates: ["userApi", "user", function (userApi, user) {
                            return userApi.getUsersForDelegateUser(user.Id);
                        }],
                        onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {
                            var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                            if (onBehalfOfUserId)
                                return userApi.get(onBehalfOfUserId).catch(ng.noop);
                            return null;
                        }],
                        permissions: ["permissionApi", "permissionService", function (permissionApi, permissionService) {
                            //if (permissionService.getPermissions() === null) {
                            //    return permissionApi.getPolicyStatements().then(function (response) {
                            //        permissionService.setPermissions(response);
                            //    });
                            //}
                            //return null;

                            return permissionApi.getPolicyStatements().then(function (response) {
                                permissionService.setPermissions(response);
                            });
                        }],
                        masterAdvisorAgreementRequiredRecord: ["agreementsApi", function (agreementsApi) {
                            return agreementsApi.getMasterAdvisorAgreementRequiredRecord().then(function (model) {
                                if (model.data === "")
                                    return null;
                                return model;
                            });
                        }],
                        userMasterAdvisorAgreement: ["agreementsApi", function (agreementsApi) {
                            return agreementsApi.getLoggedInUserMasterAdvisorAgreement().then(function (agreement) {
                                if (agreement.data === "")
                                    return null;
                                return agreement;
                            }, function () {
                                return null;
                            });
                        }],
                        userOnbordingRecord: ["onboardingApi", function (onboardingApi) {
                            //return onboardingApi.getOnBordingTestRecord();                         
                            return onboardingApi.getLoggedInUserOnboarding().then(function (record) {
                                return record;
                            }, function () {
                                return null;
                            });
                        }],
                        // TODO: remove this whole block once transition is complete
                        // this is a fake resolve, doesn't actually do anything to the state
                        // just tests for a particular error condition that might happen in a certain circumstance, and if matches re-login.
                        // that circumstance being if a user leaves portal (eventually auto-logged out) but doesn't refresh the page (and was using old config pointing to old api),
                        // and in the meantime we push the code containing the new config pointing to new api
                        // in that case the user will eventaully click the "login again" button and start the login flow - but still using the old api
                        // and when they return to UI after figauth, they will have logged in to old api but UI will be looking at new api
                        newApiTest: ["portalBaseApiUrl", "AuthService", "$http", "$q", function (portalBaseApiUrl, AuthService, $http, $q) {
                            // only operate on prod
                            if (window.location.hostname !== "portal.figmarketing.com")
                                return null;

                            // sanity check, we shouldn't even be entering this state if we don't have the timer cookie
                            if (!AuthService.isAuthenticated())
                                return null;

                            // during testing this will only be /api for users who opt in to feature flag
                            if (portalBaseApiUrl !== "/api")
                                return null;

                            // at this point, user is pointing to new api, and AuthService thinks we are authenticated
                            // check if we can actually make requests, or if we have a cookie for the wrong domain
                            return $http.get("/api/Ping")
                                .then(function (newPingResponse) {
                                    if (newPingResponse.data.IsAuthenticated)
                                        return null; // all is good - ping to new api succeeded

                                    return $http.get("https://api.portal.figmarketing.com/Ping", { withCredentials: true }).then(function (oldPingResponse) {
                                        if (!oldPingResponse.data.IsAuthenticated) {
                                            // here, we are not authenticated with either old or new, so something weird is going on - should not get this far
                                            // and if we somehow do, it is an unrelated issue that would be breaking the page anyway, so we won't interfere
                                            return null;
                                        }

                                        // at this point, the UI is pointing to the new api
                                        // but we are only authenticated with the old api and not the new one
                                        // (that means code was updated during our login flow)
                                        // we should restart the login process using the new api, and include the auto-login flag to not prompt the user again
                                        // and bring them back to the same page they were on
                                        window.location = "/api/Login/Fig/Redirect?autoLogin=true&redirectUri=" + window.encodeURIComponent("/" + window.location.hash);
                                        return null; // not needed, just for consistsency
                                    });
                                })
                                .catch(function () { return null; }); // catch-all to not affect the resolve at all
                        }]
                    }
                });
        }
    ]);

    app.component("home",
        {
            templateUrl: "App/Home/Home.html",
            controller: "HomeController",
            bindings: {
                user: "<",
                //marketingDollars: "<",
                userGroup: "<",
                logo: "<",
                delegates: "<",
                onBehalfOfUser: "<",
                masterAdvisorAgreementRequiredRecord: "<",
                masterAdvisorAgreements: "<",
                userMasterAdvisorAgreement: "<",
            }
        });

    app.run([
        "$transitions", "$window", function ($transitions, $window) {
            $transitions.onSuccess({},
                function (trans) {
                    var to = trans.to();
                    var title = "", obj;

                    if (to.PageTitle) {
                        title = to.PageTitle + " | ";
                    }
                    //TODO: insert call to client.Name
                    title += "Agent Portal";

                    $window.document.title = title;
                });
        }
    ]);
    app.controller("HomeController", ["$cookies", "homeApi", "$state", "$mdDialog", "$mdSidenav", "arcBusinessApi", "ssoApi", "permissionApi", "permissionService", "_", "userApi", "marketplaceSettings", "marketplaceApi", "marketplaceOneSettings", "marketplaceOneApi", "externalLoading", "AuthService", "iComplyApi", "iComplySettings", "$timeout", "onboardingApi", "amplitudeService", "stateHistory", "featureToggleService", "pointAdjustmentApi", "surveyRenewalDialog", "notificationDialog",
        function ($cookies, homeApi, $state, $mdDialog, $mdSidenav, arcBusinessApi, ssoApi, permissionApi, permissionService, _, userApi, marketplaceSettings, marketplaceApi, marketplaceOneSettings, marketplaceOneApi, externalLoading, AuthService, iComplyApi, iComplySettings, $timeout, onboardingApi, amplitudeService, stateHistory, featureToggleService, pointAdjustmentApi, surveyRenewalDialog, notificationDialog) {

            var $ctrl = this;

            // TODO: remove this in a week
            permissionService.migrateOnBehalfOfStorage();

            ng.extend($ctrl,
                {
                    ui: {
                        activeState: getState(),
                        hasMTpermission: !!permissionService.hasOnePermission("MarketingTracker:View"),
                        //TODO: remove prod check in HTML
                        hasPointAdjustmentPermission: !!permissionService.hasOnePermission("PointAdjustments:View"),
                        hasAccessMarketingPointsPermission: !!permissionService.hasOnePermission("AccessMarketingPoints:View"),
                        hasAccessAgentCPCsPermission: !!permissionService.hasOnePermission("AgentCPCs:View"),
                        startDate: new Date(new Date().getFullYear(), 0, 1),
                        endDate: getCPCQueryEndDates(),
                        maxEndDate: getCPCQueryEndDates()
                    },

                    toggleAgentInfo: toggleAgentInfo,
                    logout: logout,
                    viewLeaderboard: viewLeaderboard,
                    viewNotificationPopup: viewNotificationPopup,
                    getDelegatePermissions: getDelegatePermissions,
                    goToBlueprint: goToBlueprint,
                    goToElevateTest: goToElevateTest,
                    goToElevate: goToElevate,
                    goToElevateForLife: goToElevateForLife,
                    goToCreativeServices: goToCreativeServices,
                    redirectToMarketplace: redirectToMarketplace,
                    redirectToMarketplaceOne: redirectToMarketplaceOne,
                    hideNavBarLinks: hideNavBarLinks,
                    environment: featureToggleService.checkEnv(),
                    closeBanner: closeBanner,
                    logAppStoreVisit: logAppStoreVisit,
                    getCPCs: getCPCs,
                    goToNewPortal: goToNewPortal
                });

            stateHistory.setup();

            $ctrl.logCustomNavEvent = function (evt) {
                return amplitudeService.logCustomEvent('Main Nav Click', evt, {});
            };

            function getState() {
                return $state.$current.name.split(".", 3)[2];
            }

            function getCPCQueryEndDates() {
                var today = new Date();
                var lastDateOfMonth = new Date(today.getUTCFullYear(), today.getMonth() + 1, 0);
                var dayOfMonth = today.getDate();
                var endDate = null;
                if (dayOfMonth >= 1 && dayOfMonth <= 15) {
                    endDate = new Date(today.getUTCFullYear(), today.getMonth() - 1, 1);
                }
                if (dayOfMonth > 15 && dayOfMonth <= lastDateOfMonth.getDate()) {
                    endDate = new Date(today.getUTCFullYear(), today.getMonth(), 1);
                }

                return endDate;
            }

            function getCPCs() {
                $ctrl.logCustomNavEvent('CPC Edit');
                return homeApi.getUserCPCs($ctrl.ui.startDate.toUTCString(), $ctrl.ui.endDate.toUTCString()).then(function (cpcs) {
                    return $ctrl.cpcs = cpcs;
                });
            }

            function toggleAgentInfo() {
                $ctrl.logCustomNavEvent('Toggle Agent Info');
                $mdSidenav("user-info-expand").toggle();
            }

            function logout() {
                $ctrl.logCustomNavEvent('Log Out');
                AuthService.logout();
            }

            $ctrl.delegateId = permissionService.getUserDelegateId();

            function hideNavBarLinks() {

                if (permissionService.getOnBehalfOfUserId() === null) {
                    //MAA Checks (Opt Out No Longer Allowed)
                    var isOptedOut = permissionService.getOptOutMasterAdvisorAgreement() === null ? false : true;
                    var isSigningRequired = $ctrl.masterAdvisorAgreementRequiredRecord !== null ? true : false;
                    var isAlreadySigned = $ctrl.userMasterAdvisorAgreement === null ? false : true;
                    var isOnboardingWizardRequired =
                        !!$ctrl.userOnbordingRecord && $ctrl.userOnbordingRecord.InfoValidated === null
                            ? true
                            : false;

                    var hideLinks = false;
                    if (isOnboardingWizardRequired) {
                        hideLinks = true;
                    } else {
                        if (isSigningRequired) {
                            if (!isAlreadySigned && !isOptedOut
                            ) {

                                hideLinks = true;
                            }
                        }
                    }

                    return hideLinks;
                }
            }

            function getDelegatePermissions(delegateId) {
                $ctrl.delegateId = delegateId;
                var delegate = _.find($ctrl.delegates, function (row) { return row.Id === delegateId; });
                if (delegate) {
                    permissionService.setOnBehalfOfUserId(delegate.OnBehalfOfUserId);
                    permissionService.setUserDelegateId(delegate.Id);
                    return permissionApi.getDelegatePermissions(delegate.Id).then(function (permissions) {
                        permissionService.setPermissions(permissions);

                        if ($state.includes("Home.Tools.MarketingTracker")) {
                            $state.go("Home.Tools.MarketingTrackerNew", { mtLoad: true }, { reload: true });
                        }
                        else //$state.go($state.current, {}, { reload: true });
                            $state.go("Home.Dashboard", {}, { reload: true });
                    });
                } else {

                    return userApi.getLoggedInUserPermissions().then(function (permissions) {
                        permissionService.removeStoredOnBehalfOfUserId();
                        permissionService.setPermissions(permissions);

                        if ($state.includes("Home.Tools.MarketingTracker")) {
                            $state.go("Home.Tools.MarketingTrackerNew", { mtLoad: true }, { reload: true });
                        }
                        else //$state.go($state.current, {}, { reload: true });
                            $state.go("Home.Dashboard", {}, { reload: true });
                    });
                }
            }

            function viewLeaderboard($event) {
                var data = null;
                if ($event === "marketingDetails") {
                    data = $ctrl.marketingDollars;
                    $ctrl.logCustomNavEvent('Marketing Dollar Details');
                } else {
                    $ctrl.logCustomNavEvent('View Leaderboard');
                }

                $mdDialog.show({
                    targetEvent: $event,
                    controller: "leaderboardController",
                    controllerAs: "$ctrl",
                    templateUrl: "App/Home/Leaderboard/leaderboard-template.html",
                    clickOutsideToClose: true,
                    bindToController: true,
                    resolve: {
                        data: [
                            "leaderboardApi", function (leaderboardApi) {
                                if (data === null) return leaderboardApi.get();
                                return data;
                            }
                        ]
                    }
                });
            }

            function viewNotificationPopup($event) {
                $ctrl.logCustomNavEvent('Covid 19 Pop-up');
                notificationDialog.open($event);
            }

            $ctrl.redeemMarketingDollars = function ($event) {
                $ctrl.logCustomNavEvent('Redeem Marketing Dollar');
                $mdDialog
                    .show({
                        targetEvent: $event,
                        controller: "redeemMarketingDollarsController",
                        controllerAs: "$ctrl",
                        templateUrl: "App/Home/RedeemMarketingDollars/redeem-dollars-template.html",
                        bindToController: true,
                        marketingDollars: $ctrl.marketingDollars,
                        user: $ctrl.user,
                        onBehalfOfUser: $ctrl.onBehalfOfUser,
                        marketingConsultant: $ctrl.marketingConsultant
                    })
                    .then(function () {
                        _getAgentMarketingDollars();
                    });
            };

            this.ActivateElevateSso = function () {
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateElevateSso().then(function (data) {

                    w.document.write(data);
                    w.document.forms.platinum.submit();
                }, function () {
                    w.document.write(" Failed.  There was an error accessing this resource.");
                });
            };

            function goToBlueprint() {
                $ctrl.logCustomNavEvent('FIG Blueprint');
                window.open('https://www.figmarketing.com/blog/', '_blank');
            }

            function goToElevateTest() {
                redirectToMarketplace("Elevate");
            }

            function goToElevate() {

                // redirectToMarketplace("Elevate");

                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateElevateSso().then(function (data) {
                    w.document.write(data);
                    w.document.forms.platinum.submit();
                }, function () {
                    w.document.write(" Failed.  There was an error accessing this resource.");
                });
            }

            function goToElevateForLife() {

                // redirectToMarketplace("ElevateForLife");
                if (permissionService.hasOnePermission("ElevateForLife:Access")) {
                    $state.go("Home.Tools.MarketPlace.ElevateLifeAssets.Default");
                }

            }

            function goToCreativeServices() {

                // redirectToMarketplace("CreativeServices");

                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateCreativeServicesSso().then(function (data) {
                    w.document.write(data);
                    w.document.forms.platinum.submit();
                }, function () {
                    w.document.write(" Failed.  There was an error accessing this resource.");
                });
            }

            function redirectToMarketplace(environment) {
                $ctrl.logCustomNavEvent('Marketplace');
                return marketplaceApi.getToken().then(function (token) {
                    // var expiration = localStorage.getItem("Auth.Expiration");
                    var now = new Date();
                    now.setTime(now.getTime() + 45 * 60 * 1000);
                    var expiration = now.toISOString();
                    var url = marketplaceSettings.baseUrl +
                        "/Sso?accesstoken=" +
                        token +
                        "&environment=" +
                        environment + "&expiration=" + expiration;
                    if ($ctrl.delegateId) {
                        var delegate = _.find($ctrl.delegates, function (row) { return row.Id === $ctrl.delegateId; });
                        if (delegate)
                            url += "&onBehalfOfUserId=" + delegate.OnBehalfOfUserId;
                    } else if ($ctrl.onBehalfOfUser)
                        url += "&onBehalfOfUserId=" + $ctrl.onBehalfOfUser.Id;
                    window.location.href = url;
                });
            }

            function redirectToMarketplaceOne() {
                $ctrl.logCustomNavEvent('Marketplace One');
                return marketplaceOneApi.getToken().then(function (token) {
                    // var expiration = localStorage.getItem("Auth.Expiration");
                    var now = new Date();
                    now.setTime(now.getTime() + 45 * 60 * 1000);
                    var expiration = now.toISOString();
                    var url = marketplaceOneSettings.baseUrl +
                        "!/Sso?accesstoken=" +
                        token +
                        "&expiration=" + expiration;
                    if ($ctrl.delegateId) {
                        var delegate = _.find($ctrl.delegates, function (row) { return row.Id === $ctrl.delegateId; });
                        if (delegate)
                            url += "&onBehalfOfUserId=" + delegate.OnBehalfOfUserId;
                    } else if ($ctrl.onBehalfOfUser)
                        url += "&onBehalfOfUserId=" + $ctrl.onBehalfOfUser.Id;
                    window.location.href = url;
                });
            }

            this.redirectToIcomplyLite = function () {
                var w = window;
                $ctrl.logCustomNavEvent('iComply Lite');

                iComplyApi.getFastTrackToken().then(function (result) {
                    w.document.write(externalLoading.html);
                    var auth = JSON.parse(result.Auth);
                    var url = iComplySettings.baseUrl +
                        "/Sso?accesstoken=" + auth.Token +
                        "&expiration=" + auth.Expiration +
                        "&fasttrack=true";

                    if (result.OnBehalfOfUserFigAuthId !== null) {
                        url += "&onbehalfofauthuserid=" + result.OnBehalfOfUserFigAuthId;
                    }

                    w.location.href = url;
                },
                    function error(x) {
                        console.log(x.data);
                        //w.document.write("SSO Failed.  There was an error accessing this resource.");
                        $ctrl.ssoError = true;
                        //$state.go("Home.Tools.EApps", {}, { reload: true });
                        //w.location.href = "/OldPortal/#/Tools/EApps";

                        $timeout(function () {
                            $state.go("Home.Tools.Applications.EApps");
                        });
                    });
            };

            function _displayBanner() {
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;

                $ctrl.banner = {
                    isHidden: false,
                    os: 'Unknown',
                    message: '<span>Psst...We now have a mobile app! Download the FIG Marketing app to view your FIG business and stay up-to-date with industry news and media.</span>'
                };

                // Windows must come first because its UA also contains "Android"
                if (/windows/i.test(userAgent)) {
                    $ctrl.banner.os = 'Windows';
                    message = '<span>Psst...We now have a mobile app! Download the FIG Marketing app to view your FIG business and stay up-to-date with industry news and media.</span>';
                }

                if (/android/i.test(userAgent)) {
                    $ctrl.banner.os = 'Android';
                    $ctrl.banner.message = '<span>We now have a mobile app!</span>';
                }

                // iOS detection from: http://stackoverflow.com/a/9039885/177710
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    $ctrl.banner.os = 'iOS';
                    $ctrl.banner.message = '<span>We now have a mobile app!</span>';
                }
                // compare createdDate to today minus 30
                var createdDate = moment($ctrl.user.CreatedDate),
                    today = moment().subtract(30, "day");

                $ctrl.banner.isHidden = today.isAfter(createdDate)
                    ? true
                    : $cookies.get("hide-app-banner") === "true"
                        ? true
                        : false;

                return $ctrl.banner;
            }

            //Dismissing banner will set a cookie with exp of 24 hour. Afterward the banner will show again?
            function closeBanner() {
                var now = new Date();
                exp = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

                $cookies.put('hide-app-banner', 'true');
                $ctrl.banner.isHidden = true;
                amplitudeService.logClickEvent('Banner Dismiss Button');
            }

            function logAppStoreVisit() {
                $cookies.put('hide-app-banner', 'true');
                $ctrl.banner.isHidden = true;
                amplitudeService.logClickEvent('Banner App Store Button');
            }

            function _getAgentMarketingDollars() {
                return homeApi.getUserMarketingDollars().then(function (dollars) {
                    $ctrl.marketingDollars = dollars;
                    return dollars;
                }, function () {
                    $ctrl.marketingDollars = 0;
                    return 0;
                });
            }

            function goToNewPortal() {
                $cookies.put('default-view', 'new');
                $cookies.remove('new-portal-optout');
                window.location.href = '/Portal/Dashboard';
                amplitudeService.logClickEvent('New Portal Opt-in');
                amplitudeService.logUserProperties({
                    NewPortalOptin: true,
                });
            }

            function checkNewPortalOptout() {
                var optout = $cookies.get('new-portal-optout') === 'true' ? true : false;

                if (optout) {
                    amplitudeService.logClickEvent('New Portal Opt-out');
                    amplitudeService.logUserProperties({
                        NewPortalOptin: false,
                    });
                }

            }

            $ctrl.$onInit = function () {
                checkNewPortalOptout();
                _displayBanner();
                _getAgentMarketingDollars();
                $ctrl.seePortalBeta = $ctrl.environment === 'prod' ? permissionService.emailDomainAllowed($ctrl.user.Email) : true;
                pointAdjustmentApi.getMarketingConsultant()
                    .then(function (response) {
                        $ctrl.marketingConsultant = response;
                        $ctrl.hasMarketingConsultant = true;
                    })
                    .catch(function () {
                        $ctrl.hasMarketingConsultant = false;
                    });
                getCPCs();
            };
        }]);

})(window.angular, window.app); // jshint ignore:line